var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.2,5.253h3.75A.251.251,0,0,0,28.2,5h0a1.163,1.163,0,0,0-.417-.887L24.574,1.44a1.558,1.558,0,0,0-.858-.308h0a.308.308,0,0,0-.308.308V4.461A.8.8,0,0,0,24.2,5.253Z",
    transform: "translate(-7.703 -0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.917,4.458V1.125H11.458a1.337,1.337,0,0,0-1.333,1.333v14a1.337,1.337,0,0,0,1.333,1.333h10a1.337,1.337,0,0,0,1.333-1.333V6.333h-4A1.878,1.878,0,0,1,16.917,4.458Z",
    transform: "translate(-2.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.667,19.458V5.625H5.833A1.337,1.337,0,0,0,4.5,6.958V21.625a1.337,1.337,0,0,0,1.333,1.333H16.5a1.337,1.337,0,0,0,1.333-1.333v-.833H8A1.337,1.337,0,0,1,6.667,19.458Z",
    transform: "translate(0 -1.833)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCopyIcon);
export default __webpack_public_path__ + "static/media/dark-copy-icon.2731e1f9a3a847444fbaad4d41ba6270.svg";
export { ForwardRef as ReactComponent };